/// <reference path="../../typings/tsd.d.ts" /> 
module warsApp.services {
    export class RelatedClaimProcessTypeService extends DataService<Wars.Domain.Model.RelatedClaimProcessType>{

        constructor(breeze: any, $q: angular.IQService, private $http: angular.IHttpService) {
            super(breeze, $q);
        }

        public getRelatedClaims(processConfigurationId: string): angular.IPromise<Wars.Domain.Model.RelatedClaimProcessType[]> {
            const query = this.breezeModule.EntityQuery
                .from("RelatedClaimProcessTypes")
                .where('processConfiguration_id', '==', processConfigurationId)
                .expand("relatedClaims, field.autoCompleteConfiguration.processType");

            return this.executeQuery(query); 
        }

        public createNewRelatedClaim(): Wars.Domain.Model.RelatedClaim {
            return <Wars.Domain.Model.RelatedClaim>this.createNewEntity("RelatedClaim");
        }


        public createNewRelatedClaimProcessType(): Wars.Domain.Model.RelatedClaimProcessType {
            return <Wars.Domain.Model.RelatedClaimProcessType>this.createNewEntity("RelatedClaimProcessType");
        }


    }
}

warsApp.registerService('RelatedClaimProcessTypeService', ['breeze','$q', '$http']);